import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { LOGO_URL, TAGLINE } from "@/constants/site";

export const Preloader = ({ onComplete }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const duration = 1900;
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / duration);
      setCount(Math.round(p * 100));
      if (p < 1) {
        raf = requestAnimationFrame(tick);
      } else {
        setTimeout(onComplete, 500);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <motion.div
      data-testid="logo-reveal-preloader"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-royal-deep"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.82 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
        className="relative"
      >
        <div className="absolute -inset-5 rounded-full border border-gold/30" />
        <div
          className="absolute -inset-5 rounded-full border-t-2 border-gold"
          style={{ animation: "slow-spin 2.4s linear infinite" }}
        />
        <img
          src={LOGO_URL}
          alt="Rayasthaila logo"
          data-testid="preloader-logo"
          className="h-40 w-40 rounded-full bg-white object-contain p-2 shadow-[0_0_80px_rgba(212,175,55,0.25)] sm:h-52 sm:w-52"
        />
      </motion.div>

      <div className="mt-12 overflow-hidden">
        <motion.p
          initial={{ y: "120%" }}
          animate={{ y: 0 }}
          transition={{ delay: 0.5, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="px-4 text-center font-mono text-[10px] uppercase tracking-[0.35em] text-gold sm:text-xs"
        >
          {TAGLINE}
        </motion.p>
      </div>

      <div className="relative mt-10 h-px w-52 overflow-hidden bg-white/10">
        <div
          className="absolute inset-y-0 left-0 bg-gradient-to-r from-gold-pale via-gold to-gold-dark transition-[width] duration-100"
          style={{ width: `${count}%` }}
        />
      </div>
      <p className="mt-4 font-mono text-xs tabular-nums text-slate-500" data-testid="preloader-counter">
        {count}%
      </p>
    </motion.div>
  );
};
